import register from './register.js';

function init() {

}

register( 'index', init );

export default undefined;
